const CONFIG = {
  // Window Breakpoints
  BREAKPOINTS: {
    LG: 1025,
  },
  // Breakpoints for <picture></picture>
  PICTURE_BREAKPOINTS: {
    MOBILE: 599,
    DESKTOP: 600,
  },
  // Y-Scroll Position which enables UpToTop Component
  SCROLL: {
    ACTIVE_POS: 20,
  },

  IE_WHITE_LIST: [
    '/business/veralteter-browser.html',
    '/enterprise/Listenpreise.html',
    '/business/business-portale.html',
  ],
};

export default CONFIG;
